import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { AccountContext } from "context/account";
import api from "services/api";
import toast from "react-hot-toast";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Avatar from "@mui/material/Avatar";

import ReactPlayer from "react-player";

const VideoPlayCard2 = ({
  title,
  src,
  imgSrc,
  description,
  textProps = {},
  cardProps = {},
  handleClick,
  videoProps = {},
  ...rest
}) => {
  const [isHover, setIsHover] = useState(false);

  const account = useContext(AccountContext);
  const navigate = useNavigate();

  return (
    <div>
      <div onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        <SuiBox
          onClick={handleClick}
          className="video-card-hover-parent h-[330px] bg-gray-200 rounded-3xl flex flex-col justify-end relative cursor-pointer shadow-lg"
          style={{ ...cardProps }}
        >
          <div className="video-card-hover-child absolute inset-0 rounded-2xl bg-gray-200 w-full overflow-hidden">
            {imgSrc ? (
              <img src={imgSrc} alt={title} style={{ width: "100%", height: "100%" }} />
            ) : (
              <ReactPlayer
                controls={false}
                url={src}
                height="100%"
                width="100%"
                playing={isHover ? true : false}
                loop={true}
                className="video-play-card-wrap"
                {...videoProps}
              />
            )}
            {/* <div>
              <img src={src} className="video-play-card-wrap" />
            </div> */}
          </div>
          <div className="p-6 flex flex-col gap-2 text-gray-700 dark:text-gray-200 h-[123px]">
            <SuiBox sx={{ ...textProps }}>
              <SuiTypography
                variant="h5"
                textTransform="none"
                color="inherit"
                sx={{
                  fontWeight: "bold",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                }}
              >
                {title}
              </SuiTypography>{" "}
              <Tooltip title={description}>
                <SuiTypography
                  variant="body1"
                  textTransform="none"
                  color="inherit"
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {description}
                </SuiTypography>
              </Tooltip>
            </SuiBox>
          </div>
        </SuiBox>
      </div>
    </div>
  );
};
export default VideoPlayCard2;
